"use strict";
// wklr-admin-api/src/model/duration.ts からのコピペ。統合したい。
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDurationState = getDurationState;
function getDurationState(now, _from, _until) {
    const from = typeof _from === 'string' ? new Date(_from) : _from;
    const until = typeof _until === 'string' ? new Date(_until) : _until;
    if (from !== null && until !== null && from.getTime() >= until.getTime()) {
        throw Error(`fromとuntilの前後関係が逆転しています: ${from} 〜 ${until}`);
    }
    if (from === null && until === null) {
        return 'no';
    }
    if (from !== null && now.getTime() < from.getTime()) {
        return 'before';
    }
    if (until !== null && until.getTime() <= now.getTime()) {
        return 'after';
    }
    return 'within';
}
